import React from "react";
import styles from "./AdventureInfo.module.css";
import { FaUsers, FaBookOpen, FaMountain } from "react-icons/fa";

const AdventureInfo = () => {
  return (
    <section className="container py-5">

      {/* Header */}
      <div className="text-center mb-4">
        <h2 className="fw-bold">Skydiving 2.0</h2>
        <p className="text-muted fs-5">
          Experience the Thrill from 10,000 Feet
        </p>
      </div>

      {/* Description */}
      <div className="mb-4">
        <p>
          Jharkhand Tourism Department, in collaboration with{" "}
          <strong>Sky High India</strong>, proudly presents the{" "}
          <strong>Skydiving Festival 2026</strong> — a unique initiative aimed at
          promoting adventure tourism in the state.
        </p>

        <p className="fw-semibold mt-3 mb-2">
          Event Locations & Dates:
        </p>
        
        <div className="ps-2">
          <div className="mb-1">
            <strong>Jamshedpur:</strong> 21 March – 29 March 2026
          </div>
          <div>
            <strong>Dumka:</strong> 1 April – 6 April 2026
          </div>
        </div>

        <p className="mt-3">
          Adventure enthusiasts can book their experience via{" "}
          <a
            href="https://www.skyhighindia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none fw-semibold"
          >
            www.skyhighindia.com
          </a>
        </p>

        <p>
          Building on the success of previous editions, this year’s festival offers
          an unforgettable opportunity to skydive from approximately{" "}
          <strong>10,000 feet</strong>, guided by certified professional instructors.
        </p>
      </div>

      {/* Image */}
      <div className="mb-5">
        <div className="position-relative">
          <img
            src="/images/sky-diving/Sky_diving2.0.png"
            alt="Skydiving Festival Jharkhand"
            className="img-fluid rounded w-100"
            style={{ cursor: "default" }}
          />
          <div className="position-absolute bottom-0 start-0 m-3 px-3 py-1 bg-dark bg-opacity-50 text-white rounded">
            Feel the Adrenaline Rush
          </div>
        </div>
      </div>

    </section>
  );
};

export default AdventureInfo;
